function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("path", {
  d: "M43.954 54H6V6.401h33.82"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.588 48.99V6a4.384 4.384 0 10-8.727-.851h-.041v43.84"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.455 46.484c2.255 5.69-4.635 5.493-4.635 1.879a4.384 4.384 0 118.769 0c0 3.662-2.01 5.637-4.432 5.637"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 12,
  cy: 15.5,
  rx: 3,
  ry: 5.5
})), /*#__PURE__*/React.createElement("path", {
  d: "M12 13v13M29 41l3-10 3 10h-2l3 5h-8l3-5zM32 46v3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 29v0l3 10H9z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 39v3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 29v0l3 10h-6z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 39v3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 48c23.287 4.226-.59-31.069 19-35",
  strokeDasharray: "3, 3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.061 46.439L8.94 48.56M11.061 48.561L8.94 46.44"
}), /*#__PURE__*/React.createElement("path", {
  strokeDasharray: "0.1, 0.1",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M33 9h5v3h-5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33 12v5"
}));

var SvgMap = function SvgMap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Map.0d1b01bb.svg";
export { ForwardRef as ReactComponent };